import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { useApp } from '../context/AppContext';

// Übergangsseite: Die Bestätigung per Link wurde durch einen 6-stelligen
// Code ersetzt. Alte E-Mails enthalten noch Links auf diese Route —
// wer hier landet, meldet sich einfach an und bekommt den Code zugeschickt.
export default function VerifyEmailPage() {
  const navigate = useNavigate();
  const { openAuth } = useApp();

  return (
    <div style={{
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', minHeight: '70vh', gap: '14px',
      padding: '24px', textAlign: 'center',
    }}>
      <Mail size={52} color="#2563eb" />
      <h1 style={{ fontSize: '22px', fontWeight: 800, color: '#111827' }}>
        Bestätigung läuft jetzt per Code
      </h1>
      <p style={{ color: '#6b7280', fontSize: '15px', maxWidth: '400px' }}>
        Wir haben die Bestätigung per Link durch einen Code ersetzt.
        Melde dich einfach mit deinen Zugangsdaten an – wir senden dir
        den Bestätigungscode automatisch per E-Mail.
      </p>
      <button
        style={{
          display: 'inline-block', background: '#2563eb', color: 'white',
          padding: '12px 28px', borderRadius: '12px', fontSize: '15px',
          fontWeight: 700, border: 'none', cursor: 'pointer', marginTop: '8px',
        }}
        onClick={() => { navigate('/', { replace: true }); openAuth('login'); }}
      >
        Zur Anmeldung
      </button>
    </div>
  );
}
